import { api, QueryDateRange, schedulingPath } from "./api";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { Month } from "../helpers/dateHelpers";
import { ISODateString } from "../types/date";
import { CustomAssignment } from "../types/scheduling/customAssignments";
import { QueryKeyBuilder } from "../query/queryKeyBuilder";

class CustomAssignmentsAPI {
  static base = schedulingPath("/custom");
  static assignmentsBase = `${CustomAssignmentsAPI.base}/assignments`;

  async getAssignments(start: ISODateString, end: ISODateString): Promise<CustomAssignment[]> {
    const dates: QueryDateRange = {
      fromDate: start,
      toDate: end,
    };
    return api.get(CustomAssignmentsAPI.assignmentsBase, { searchParams: dates }).json();
  }

  async saveAssignment(assignment: CustomAssignment): Promise<CustomAssignment> {
    const apiMethod = assignment.id ? api.put : api.post;
    let baseUrl = CustomAssignmentsAPI.assignmentsBase;
    if (assignment.id) baseUrl += `/${assignment.id}`;
    return apiMethod(baseUrl, { json: assignment }).json();
  }

  async deleteAssignment(assignment: CustomAssignment) {
    await api.delete(`${CustomAssignmentsAPI.assignmentsBase}/${assignment.id}`);
  }
}

export function useCustomAssignments(month: Month, options?: UseQueryOptions<CustomAssignment[], Error>) {
  return useQuery({
    queryKey: QueryKeyBuilder.CustomAssignments(month.start(), month.end()),
    queryFn: () => customAssignmentsApi.getAssignments(month.start(), month.end()),
    ...options,
  });
}

export const customAssignmentsApi = new CustomAssignmentsAPI();
